import {
  CalendarDays,
  ClipboardList,
  Database,
  MessageSquare,
  Phone,
  ShieldCheck,
  WandSparkles,
  UserRoundCog,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { EMPLOYEE_NAV_CHILDREN, employeeNavForWorkspace } from './employeeNav';
import { TASK_NAV_CHILDREN, taskNavForWorkspace } from './taskNav';

export type LeafItem = {
  kind: 'leaf';
  to: string;
  label: string;
  Icon: LucideIcon;
};

export type GroupItem = {
  kind: 'group';
  id: string;
  label: string;
  Icon: LucideIcon;
  children: { to: string; label: string }[];
};

export type NavItem = LeafItem | GroupItem;

export const PRIMARY_NAV_ITEMS: NavItem[] = [
  { kind: 'leaf', to: '/chat', label: 'Chat', Icon: MessageSquare },
  { kind: 'leaf', to: '/calls', label: 'Calls', Icon: Phone },
  {
    kind: 'group',
    id: 'task-management',
    label: 'Task Management',
    Icon: ClipboardList,
    children: TASK_NAV_CHILDREN.map(({ to, label }) => ({ to, label })),
  },
  {
    kind: 'group',
    id: 'employee-hub',
    label: 'Employee Hub',
    Icon: UserRoundCog,
    children: EMPLOYEE_NAV_CHILDREN.map(({ to, label }) => ({ to, label })),
  },
  // Route stays /leo (internal); only the label is the product name.
  { kind: 'leaf', to: '/leo', label: 'Lio', Icon: WandSparkles },
  { kind: 'leaf', to: '/calendar', label: 'Calendar', Icon: CalendarDays },
  { kind: 'leaf', to: '/dbms', label: 'DBMS', Icon: Database },
];

export const primaryNavForWorkspace = (limited: boolean, chatAuditEnabled = false): NavItem[] => {
  const items: NavItem[] = chatAuditEnabled
    ? [
      ...PRIMARY_NAV_ITEMS,
      { kind: 'leaf', to: '/chat-audit', label: 'Chat Audit', Icon: ShieldCheck },
    ]
    : PRIMARY_NAV_ITEMS;
  if (!limited) return items;
  return items.flatMap((item): NavItem[] => {
    if (item.kind === 'leaf') {
      return ['/chat', '/chat-audit', '/calls', '/leo', '/calendar'].includes(item.to)
        ? [item]
        : [];
    }
    if (item.id === 'task-management') {
      return [{
        ...item,
        children: taskNavForWorkspace(true).map(({ to, label }) => ({ to, label })),
      }];
    }
    if (item.id === 'employee-hub') {
      return [{
        ...item,
        children: employeeNavForWorkspace(true).map(({ to, label }) => ({ to, label })),
      }];
    }
    return [];
  });
};
